/**
 * A fatal error that the user cannot recover from.
 */
export class FatalError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "FatalError"
  }
}
